import React from 'react';

function Services() {
  const servicesData = [
    { icon: '⚖️', title: 'Average Adjusting', content: 'Expert calculation and settlement of **General Average** and **Particular Average** claims, ensuring impartial and timely resolution according to international conventions.' },
    { icon: '🚢', title: 'Collision Liability Claims and Recoveries', content: 'Expert support in collision liability claims and recoveries, helping you secure fair outcomes with clarity and precision. Navigating collision liability and recoveries with technical insight, strong evidence handling, and strategic claims expertise. <br/> Delivering clear, effective solutions in collision liability claims and recovery actions for shipowners and insurers.' },
    { icon: '📊', title: 'Strategic Assessments, Audits and Vessel Inspections', content: `We provide strategic assessments and operational audits for ship managers and terminal operators, helping them strengthen safety, compliance, and commercial performance. Our reviews combine technical insight, regulatory understanding, and practical industry experience to evaluate management systems, operational practices, and risk controls. By identifying gaps, benchmarking performance, and offering clear, actionable recommendations, we support organizations in enhancing efficiency, meeting international standards, and building a culture of continuous improvement across their fleet and shore-side operations.<br/>
      &#8226; Continuous Improvement plans and implementation <br/>
      &#8226; Safety Critical Task Analysis Hazard and Operability Study (HAZOP) <br/>
      &#8226; Terminal Assessments based on MTMSA Ship Manager Assessment based on TMSA <br/>
      &#8226; Prepurchase inspections <br/>
      &#8226; P & I condition evaluation surveys <br/>
      &#8226; Damage assessment surveys` },
  ];

  return (
    <section id="services" className="max-w-[80rem] mx-auto px-6" style={{ paddingTop: '4rem', paddingBottom: '4rem', marginLeft: '3rem', marginRight: '3rem'  }}>
      <h2 style={{ fontSize: '1.875rem', fontWeight: '700', textAlign: 'center', marginBottom: '2.5rem' }}>
        Our Scope of Expert Services
      </h2>

      <div className="grid-cols-1-md-3">
        {servicesData.map((service, index) => (
          <article className="service-card" key={index}>
            <div className="service-card-icon">{service.icon}</div>
            <h3 className="service-card-title">{service.title}</h3>
            <p style={{ color: '#475569' }}
               dangerouslySetInnerHTML={{ __html: service.content.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') }}
            ></p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Services;